import React, { JSX } from 'react';

import { ApiTransfer, ApiTransferUnit } from '@ibe/api';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { sanitize } from '@ibe/services';

import { BookedItemComponentProps } from '../../../Models/ItemRegistry';
import getIconForItemTye from '../Base/getItemForItemType';
import SummaryTabs from '../Base/SummaryTabs';
import SummaryItem from '../../Components/Cart/SummaryItem/SummaryItem';
import Dates from '../Dates';
import fallback from '../../../_Translations/generated/summary.en.t.json';
import Keys from '../../../_Translations/generated/summary.en.t.json.keys';
import useTranslation from '../../../ISO/Hooks//useTranslation';
import DateDisplay from '../../Components/UI/DateDisplay/DateDisplay';

const Summary = (props: BookedItemComponentProps): JSX.Element => {
  const {
    showNumberOfPerson,
    item,
    isOpen,
    showInfo,
    showTraveler,
    showSsr,
    booking,
    onDelete,
    customPriceModifier,
    order,
    showPricePlusMinus
  } = props;

  const icon = getIconForItemTye(item.itemType);
  const { t } = useTranslation('summary', fallback, Keys);

  const numberOfPersonLabel = showNumberOfPerson
    ? t(Keys.numberOfPerson, {
        count: Object.keys(item.priceByPersonId).length,
        numberOfPerson: Object.keys(item.priceByPersonId).length
      })
    : '';

  const unit = booking.items.find(it => it.id === item.idParent) as ApiTransferUnit;
  const transfer = booking.items.find(it => it.id === unit.idParent) as ApiTransfer;

  const InfoTabContent = (): JSX.Element => {
    return (
      <>
        <div dangerouslySetInnerHTML={{ __html: sanitize(item.name) }} />
        <div dangerouslySetInnerHTML={{ __html: sanitize(item.description) }} />
        {numberOfPersonLabel ? (
          <div dangerouslySetInnerHTML={{ __html: sanitize(numberOfPersonLabel) }} />
        ) : null}
        <br />
        <div>
          <DateDisplay date={item.startDate || ''} /> {unit.pickupTime} -{' '}
          <DateDisplay date={item.endDate || ''} /> {unit.dropOffTime}
        </div>
      </>
    );
  };

  const customPrice = customPriceModifier && customPriceModifier(item);
  return (
    <SummaryItem
      title={transfer.name || ''}
      price={customPrice || item.price}
      subtitle={item.itemType}
      description={transfer.description}
      icon={<Icon icon={icon} />}
      dates={<Dates item={item} />}
      isOpen={isOpen}
      onDelete={onDelete}
      booking={booking}
      item={item}
      order={order?.Transfer}
      numberOfPerson={numberOfPersonLabel}
      showPricePlusMinus={showPricePlusMinus}
    >
      {(showInfo || showTraveler || showSsr) && (
        <SummaryTabs
          booking={booking}
          item={item}
          info={<InfoTabContent />}
          showInfo={showInfo}
          showTraveler={showTraveler}
          showSsr={showSsr}
        />
      )}
    </SummaryItem>
  );
};

export default Summary;
